// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.popup-content {
  background-color: var(--gray-color) !important;
  border-radius: 5px !important;
  min-width: 300px;
  max-width: 500px;
}

.note {
  margin: 20px 20px;
  border-radius: 4px;
  border-style: solid;
  border-width: 0.5px;
  background-color: rgb(231, 231, 231);
  padding: 10px;
  margin-bottom: 10px;
  text-align: justify;
}

.custom-input {
  border-radius: 4px !important;
  margin-top: 15px;
  margin-bottom: 15px;
}

.btn-save {
  border-radius: 5px !important;
}`, "",{"version":3,"sources":["webpack://./src/components/Board/BookmarksPanel/NoteModal/NoteModal.scss"],"names":[],"mappings":"AAAA;EACI,8CAAA;EACA,6BAAA;EACA,gBAAA;EACA,gBAAA;AACJ;;AAEA;EACI,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,mBAAA;EACA,oCAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;AACJ;;AAEA;EACI,6BAAA;EACA,gBAAA;EACA,mBAAA;AACJ;;AAEA;EACI,6BAAA;AACJ","sourcesContent":[".popup-content{\n    background-color: var(--gray-color) !important;\n    border-radius: 5px !important;\n    min-width: 300px;\n    max-width: 500px;\n}\n\n.note {\n    margin: 20px 20px;\n    border-radius: 4px;\n    border-style: solid;\n    border-width: 0.5px;\n    background-color: rgb(231, 231, 231);\n    padding: 10px;\n    margin-bottom: 10px;\n    text-align: justify;\n}\n\n.custom-input{\n    border-radius: 4px !important;\n    margin-top: 15px;\n    margin-bottom: 15px;\n}\n\n.btn-save{\n    border-radius: 5px !important;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
